import { SortDir } from '__generated__';

import { SortDirection } from 'shared/components/data/Sort';

/**
 * Serialize sort array to query string.
 */
export const serializeSort = (sorts: SortDirection[]) => {
  const results: string[] = [];

  for (const sort of sorts) {
    if (sort.direction === SortDir.Asc) {
      results.push(sort.prop);
    } else {
      results.push(`-${sort.prop}`);
    }
  }

  return results.join(',');
};

/**
 * Deserialize sort query string to object.
 */
export const deserializeSort = (
  sortStr?: string,
  defaultSort?: SortDirection[]
) => {
  const result: SortDirection[] = [];

  if (sortStr) {
    const sorts = sortStr.split(',');
    for (const sort of sorts) {
      const indicator = sort[0] === '-';
      const direction = indicator ? SortDir.Desc : SortDir.Asc;
      const prop = indicator ? sort.substring(1, sort.length) : sort;

      result.push({
        direction,
        prop,
      });
    }
  }

  if (!result.length && defaultSort) {
    result.push(...defaultSort);
  }

  return result;
};
